import React from 'react';

import AnchorActivityItem from '../AnchorActivityItem/AnchorActivityItem';
import ArchivedItem from '../ArchivedItem/ArchivedItem';

const ArchiveableItem = (props) => {
  const { filename, actionTypeLabel, isDeleted, onClickFile, title, useTitle } = props;
  const label = useTitle ? title : actionTypeLabel;
  let content = null;

  if (isDeleted) {
    content = <ArchivedItem actionTypeLabel={label} filename={filename} />;
  } else {
    content = (
      <AnchorActivityItem actionTypeLabel={label} filename={filename} onClickFile={onClickFile} />
    );
  }

  return <React.Fragment>{content}</React.Fragment>;
};

export default ArchiveableItem;
